export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-brush/src/event.js
// module id = ../../../../d3-brush/src/event.js
// module chunks = vendor